import { render } from "./ShiftView.vue?vue&type=template&id=37241f20&scoped=true"
import script from "./ShiftView.vue?vue&type=script&lang=js"
export * from "./ShiftView.vue?vue&type=script&lang=js"

import "./ShiftView.vue?vue&type=style&index=0&id=37241f20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37241f20"]])

export default __exports__